import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {UserSecurityContent} from "./UserSecurityContent";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class UserSecurityClass extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulUserUpdated = this.afterSuccessfulUserUpdated.bind(this);
    }

    afterSuccessfulUserUpdated() {
        const { t } = this.props;
        alert(t('user.user_updated_successfully'))
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <UserSecurityContent userId={this.props.match.params.id}
                                     afterSuccessfulUserUpdated={this.afterSuccessfulUserUpdated}/>
            </div>
        )
    }
}
const UserSecurity = withRouterParams(withTranslation()(UserSecurityClass));
export default UserSecurity;
